import { render, staticRenderFns } from "./memberStaffChoose.vue?vue&type=template&id=e9043ba6&scoped=true&"
import script from "./memberStaffChoose.vue?vue&type=script&lang=js&"
export * from "./memberStaffChoose.vue?vue&type=script&lang=js&"
import style0 from "./memberStaffChoose.vue?vue&type=style&index=0&id=e9043ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9043ba6",
  null
  
)

component.options.__file = "memberStaffChoose.vue"
export default component.exports